import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { checklistsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Options($search: String, $page: Int, $filter: OptionFilter) {
    options(search: $search, page: $page, filter: $filter) {
      id
      reference
      name
    }
  }
`

export const useOptionsLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: checklistsClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'options']))
  }
}

const OptionSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useOptionsLoader(filter)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      {...props}
    />
  )
}

export default OptionSelect
